import { render, staticRenderFns } from "./LocationTopSales.vue?vue&type=template&id=6c667eab&"
import script from "./LocationTopSales.vue?vue&type=script&lang=js&"
export * from "./LocationTopSales.vue?vue&type=script&lang=js&"
import style0 from "./LocationTopSales.vue?vue&type=style&index=0&id=6c667eab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports